import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-fraud-prevention',
  templateUrl: './fraud-prevention.component.html',
  styleUrls: ['./fraud-prevention.component.scss']
})
export class FraudPreventionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
